var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useDropZone, useFileDialog } from '@vueuse/core';
import Message from '@common/ui/EMessage/Message';
import { nextTick, ref, watch } from 'vue';
import { FileStatusEnum } from '@common/enums/fileStatus.enum';
import { FileCatalyst } from '@common/utils/Catalyst/FileCatalyst';
import { CatalystBlob } from '@common/utils/Catalyst/CatalystBlob';
import { FileIdentify } from '@common/utils/Catalyst/FileIdentify';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EFileUpload',
    props: /*#__PURE__*/ _mergeModels({
        disabled: { type: Boolean },
        accept: {},
        multiple: { type: Boolean, default: true },
        directory: { type: Boolean, default: false },
        replaceable: { type: Boolean, default: false },
        limitSizeErrorText: {},
        limitTypesErrorText: {},
        limitExtensionsErrorText: {},
        limitSize: { default: 0 },
        limitTypes: { default: function () { return []; } },
        limitExtensions: { default: function () { return []; } },
        customDragZoneRef: {},
        draggable: { type: Boolean, default: true }
    }, {
        "files": { default: [], required: false },
        "filesModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["change", "cancel", "changeOverDropZone"], ["update:files"]),
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var limitSizeErrorText = props.limitSizeErrorText || t('fileUpload.limitSizeErrorText');
        var limitTypesErrorText = props.limitTypesErrorText || t('fileUpload.limitTypesErrorText');
        var limitExtensionsErrorText = props.limitExtensionsErrorText || t('fileUpload.limitExtensionsErrorText');
        var modelValue = _useModel(__props, 'files');
        var fileUploadRef = ref();
        // eslint-disable-next-line vue/no-setup-props-destructure
        var _b = useFileDialog({
            accept: props.accept,
            directory: props.directory,
            multiple: props.multiple,
        }), open = _b.open, reset = _b.reset, onChange = _b.onChange;
        var onDrop = function (files) { return __awaiter(_this, void 0, void 0, function () {
            var checkedFiles, newFiles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.draggable)
                            return [2 /*return*/];
                        if (!files || files.length === 0)
                            return [2 /*return*/];
                        checkedFiles = files.filter(function (f) { return checkFileValidity(f); });
                        newFiles = checkedFiles.map(function (c) { return new FileCatalyst(new CatalystBlob(c)); });
                        modelValue.value = props.replaceable ? newFiles : __spreadArray(__spreadArray([], __read(modelValue.value), false), __read(newFiles), false);
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emit('change', modelValue.value, newFiles);
                        return [2 /*return*/];
                }
            });
        }); };
        var isOverDropZone = useDropZone(function () { return props.customDragZoneRef || fileUploadRef.value; }, onDrop).isOverDropZone;
        watch(isOverDropZone, function (value) {
            emit('changeOverDropZone', value);
        });
        var checkFileValidity = function (file) {
            var matchTypes = props.limitTypes.length > 0 && !(props.limitTypes.some(function (type) {
                // Если соответствует хоть одному из типов, то всё ок
                // Поддержка шаблонов формата 'video/*', 'audio/*' и тп
                var regularExpression = new RegExp('^' + type.replace(/\*/, '.*') + '$');
                return regularExpression.test(file.type);
            }));
            var matchExtensions = props.limitExtensions.length > 0 && !(props.limitExtensions.some(function (type) {
                return type.replace('.', '') === file.name.split('.').pop();
            }));
            var isLimit = props.limitSize && !(file.size / 1024 / 1024 <= props.limitSize);
            if (matchTypes) {
                Message.error(limitTypesErrorText);
                return false;
            }
            if (matchExtensions) {
                Message.error(limitExtensionsErrorText);
                return false;
            }
            if (isLimit) {
                if (props.limitSizeErrorText) {
                    Message.error(limitSizeErrorText);
                }
                else {
                    var sizeErrorText = t('fileUpload.sizeLimitError', { size: props.limitSize });
                    Message.error(sizeErrorText);
                }
                return false;
            }
            return true;
        };
        onChange(function (fileList) { return __awaiter(_this, void 0, void 0, function () {
            var files, pausedOldFiles, checkedNewFiles, newFilesAsFileCatalysts, uniqFiles, prevValues, _loop_1, newFilesAsFileCatalysts_1, newFilesAsFileCatalysts_1_1, file;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // если null, то произошел reset, сбрасываем данные
                        if (!fileList) {
                            modelValue.value = [];
                            emit('change', [], []);
                            return [2 /*return*/];
                        }
                        files = __spreadArray([], __read(fileList), false);
                        // если зашел в окно файлов и закрыл его не выбрав файл
                        if (files.length === 0) {
                            emit('cancel');
                            return [2 /*return*/];
                        }
                        pausedOldFiles = modelValue.value.filter(function (e) { return e.hasStatus(FileStatusEnum.PAUSED); });
                        checkedNewFiles = files.filter(function (f) { return checkFileValidity(f); });
                        newFilesAsFileCatalysts = checkedNewFiles.map(function (file) { return new FileCatalyst(new CatalystBlob(file)); });
                        uniqFiles = [];
                        prevValues = __spreadArray([], __read(modelValue.value), false);
                        _loop_1 = function (file) {
                            var sameFile = pausedOldFiles.find(function (f) { return f.getUniqHash() === file.getUniqHash(); });
                            if (sameFile) {
                                var fileBlob = new FileCatalyst(new CatalystBlob(file.getFile(), sameFile.getLink()), new FileIdentify(sameFile.getIdentifyUuid(), sameFile.getIdentifyId()));
                                fileBlob.setStatus(FileStatusEnum.WAITING);
                                uniqFiles.push(fileBlob);
                                prevValues = modelValue.value.filter(function (e) { return e !== sameFile; });
                            }
                            else {
                                uniqFiles.push(file);
                            }
                        };
                        try {
                            for (newFilesAsFileCatalysts_1 = __values(newFilesAsFileCatalysts), newFilesAsFileCatalysts_1_1 = newFilesAsFileCatalysts_1.next(); !newFilesAsFileCatalysts_1_1.done; newFilesAsFileCatalysts_1_1 = newFilesAsFileCatalysts_1.next()) {
                                file = newFilesAsFileCatalysts_1_1.value;
                                _loop_1(file);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (newFilesAsFileCatalysts_1_1 && !newFilesAsFileCatalysts_1_1.done && (_a = newFilesAsFileCatalysts_1.return)) _a.call(newFilesAsFileCatalysts_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        modelValue.value = props.replaceable ? newFilesAsFileCatalysts : __spreadArray(__spreadArray([], __read(prevValues), false), __read(uniqFiles), false);
                        // моделька обновляется позже события change поэтому ставим nextTick
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        // моделька обновляется позже события change поэтому ставим nextTick
                        _b.sent();
                        emit('change', modelValue.value, props.replaceable ? newFilesAsFileCatalysts : uniqFiles);
                        return [2 /*return*/];
                }
            });
        }); });
        __expose({
            open: open,
            reset: reset,
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "fileUploadRef",
                ref: fileUploadRef,
                class: _normalizeClass([{
                        'file-upload--disabled': _ctx.disabled
                    }, "file-upload"])
            }, [
                _renderSlot(_ctx.$slots, "default", {
                    isOverDropZone: _unref(isOverDropZone),
                    open: _unref(open),
                    reset: _unref(reset)
                }, function () { return [
                    _createVNode(_component_e_button, {
                        type: "secondary",
                        onClick: _unref(open)
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "mr-2 h-4 w-4 text-gray-300",
                                icon: "clip"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(t)('fileUpload.attachFiles')), 1)
                        ]; }),
                        _: 1
                    }, 8, ["onClick"])
                ]; })
            ], 2));
        };
    }
});
